import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubdomainService {
  getSubdomain(): string | null {
    if (typeof window === 'undefined' || !window.location) return null;

    const host = window.location.hostname;
    const parts = host.split('.');
    if (parts.length > 2) return parts[0];
    if (parts.length === 2 && parts[1] === 'localhost') return parts[0];

    return null;
  }
}
